import React, { createContext, useContext, useState, useEffect } from 'react';
import api, { setToken, clearToken } from '../lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("fb_token");
    if (token) {
      api.get("/auth/me")
        .then(r => setUser(r.data))
        .catch(() => { clearToken(); setUser(null); });
    }
  }, []);

  const login = async (credentials) => {
    const r = await api.post("/auth/login", credentials);
    setToken(r.data.access_token);
    setUser(r.data);
    return r.data;
  };

  const logout = () => {
    clearToken();
    setUser(null);
    window.location.href = '/login';
  };

  const register = async (data) => {
    const r = await api.post("/auth/register", data);
    return r.data;
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, register }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
